import { z } from 'zod/v4';
import { IUser, USER_SCHEMA } from '../user.interfaces';
import { ETokenType } from '../token-type.enum';
import { EConfigurationChannel } from '../cms/configuration/configuration.enums';

export interface ICreateTokenRequest {
  userId?: string;
  tokenType: ETokenType;
  url?: string;
  email?: string;
}

export interface IToken {
  id?: string;
  type: ETokenType;
  user: IUser;
  tokenValue: number;
  createdAt: Date;
  expiresAt: Date;
  hasBeenUsed: boolean;
}

export interface IResetPassword {
  userId: string;
  newPassword: string;
  token: number;
}

export const ACTIVATION_TOKEN_SCHEMA: z.ZodType<IToken> = z.object({
  id: z.uuid().optional(),
  type: z.enum(ETokenType),
  user: USER_SCHEMA,
  tokenValue: z.number(),
  createdAt: z.date(),
  expiresAt: z.date(),
  hasBeenUsed: z.boolean(),
});

export const DEFAULT_ACTIVATION_TOKEN: IToken = {
  id: '0d9b64e0-ffe7-428b-ab12-491ae831d0e4',
  type: ETokenType.Activation,
  user: {
    userId: '000000-0000000000-00000000',
    email: '',
    dateOfTermsAgreement: undefined,
    deletedAt: undefined,
    isActive: false,
    referenceToCustomer: '',
    salutation: '',
  },
  tokenValue: 123123,
  createdAt: new Date('2025-01-01T00:00:00.000Z'),
  expiresAt: new Date('2025-01-01T00:00:00.000Z'),
  hasBeenUsed: false,
};

export const PASSWORD_RESET_TOKEN_SCHEMA: z.ZodType<IToken> = z.object({
  id: z.uuid().optional(),
  type: z.enum(ETokenType),
  user: USER_SCHEMA,
  tokenValue: z.number(),
  createdAt: z.date(),
  expiresAt: z.date(),
  hasBeenUsed: z.boolean(),
});

export const DEFAULT_PASSWORT_RESET_TOKEN: IToken = {
  id: '1d9b64e0-ffe7-428b-ab12-491ae831d0e4',
  type: ETokenType.PasswordReset,
  user: {
    userId: '000000-0000000000-00000000',
    email: '',
    dateOfTermsAgreement: undefined,
    deletedAt: undefined,
    isActive: false,
    referenceToCustomer: '',
    salutation: '',
  },
  tokenValue: 123123,
  createdAt: new Date('2025-01-01T00:00:00.000Z'),
  expiresAt: new Date('2025-01-01T00:00:00.000Z'),
  hasBeenUsed: false,
};

export const RESET_PASSWORD_SCHEMA: z.ZodType<IResetPassword> = z.object({
  userId: z.string(),
  newPassword: z.string(),
  token: z.number(),
});

export const DEFAULT_RESET_PASSWORD: IResetPassword = {
  userId: '0d9b64e0-ffe7-428b-ab12-491ae831d0e4',
  newPassword: 'Passwort#43',
  token: 123123,
};

export interface IUserActivationRequestedEvent {
  userId: string;
  clientChannel: EConfigurationChannel;
}

export interface IUserPasswordResetRequestedEvent {
  email: string;
  url: string;
  clientChannel: EConfigurationChannel;
}
